import type { Variants } from "@/composables/useNotification"

type NotificationAppearance = {
    icon: string
    feed: {
        backgroundClass: string
    }
    banner: {
        type: keyof Variants
        permanent?: boolean
    }
}

const defaultNotificationAppearance: NotificationAppearance = {
    icon: "bell",
    feed: {
        backgroundClass: "bg-gray-400"
    },
    banner: {
        type: "info"
    }
}

const notificationAppearanceMap = new Map<string, NotificationAppearance>([
    ["App\\Notifications\\UserCreatedNotification", {
        icon: "user-plus",
        feed: {
            backgroundClass: "bg-gray-400"
        },
        banner: {
            type: "info"
        }
    }],
    ["App\\Notifications\\PlanWelcomeNotification", {
        icon: "gift",
        feed: {
            backgroundClass: "bg-green-500"
        },
        banner: {
            type: "success"
        }
    }],
    ["App\\Notifications\\PaymentIncomingNotification", {
        icon: "credit-card",
        feed: {
            backgroundClass: "bg-green-500"
        },
        banner: {
            type: "success"
        }
    }],
    ["App\\Notifications\\PaymentSuccessfulNotification", {
        icon: "credit-card",
        feed: {
            backgroundClass: "bg-blue-500"
        },
        banner: {
            type: "info"
        }
    }],
    ["App\\Notifications\\PaymentFailedNotification", {
        icon: "credit-card",
        feed: {
            backgroundClass: "bg-red-500"
        },
        banner: {
            type: "error"
        }
    }],
    ["App\\Notifications\\TrialWillEndNotification", {
        icon: "clock",
        feed: {
            backgroundClass: "bg-yellow-400"
        },
        banner: {
            type: "warning"
        }
    }],
    ["App\\Notifications\\SubscriptionDeletedNotification", {
        icon: "x-circle",
        feed: {
            backgroundClass: "bg-red-500"
        },
        banner: {
            type: "error"
        }
    }],
    ["App\\Notifications\\OrderConfirmedNotification", {
        icon: "check-circle",
        feed: {
            backgroundClass: "bg-green-500"
        },
        banner: {
            type: "success"
        }
    }],
    ["App\\Notifications\\OrderTimeChangeRequestedNotification", {
        icon: "clock",
        feed: {
            backgroundClass: "bg-yellow-400"
        },
        banner: {
            type: "warning",
            permanent: true
        },
    }]
])

export const getNotificationAppearance = (type?: string | null): NotificationAppearance => {
    if (!type) {
        return defaultNotificationAppearance
    }

    return notificationAppearanceMap.get(type) ?? defaultNotificationAppearance
}
